export default {
  name: 'transaction_payment_methods',
  component_path: 'modules/procedures/blocks/transaction/BlockTransactionPaymentMethod',
  static_mandatory: ['required']
}